/* eslint-disable jsx-a11y/interactive-supports-focus */
import { Collapse } from '@mui/material'
import { isFunction } from 'lodash'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ROUTER_PERSONAL_DASHBOARD } from '../Modules/Personal/Dashboard/configs/const'
// import PropTypes from 'prop-types'

const LogoStudio = ({ collapsed, onClick }) => {
	const navigate = useNavigate()

	const handleClick = () => {
		if (isFunction(onClick)) {
			onClick()
		} else {
			navigate(ROUTER_PERSONAL_DASHBOARD.dashboard)
		}
	}

	return (
		<div role="button" className="flex items-center gap-2 px-3 py-2 cursor-pointer" onClick={handleClick}>
			<Collapse orientation="horizontal" in={!collapsed} collapsedSize={40}>
				<div className="w-[200px]">
					<img src="/assets/images/logo_studio.png" alt="EduQuiz.io" title="EduQuiz.io" />
				</div>
			</Collapse>
		</div>
	)
}

// LogoStudio.defaultProps = {}

// LogoStudio.propTypes = {}

export default React.memo(LogoStudio)
